import { ICameraAction } from "../actions/types/cameraTypes";

type CameraState = {
  deviceId: string;
  kind: string;
  label: string;
  empty: boolean;
  error: string;
  cameras: any[];
};

const initialState: CameraState = {
  deviceId: "",
  kind: "",
  label: "",
  empty: false,
  error: "",
  cameras: [],
};

export const cameraReducer = (
  state = initialState,
  action: ICameraAction<any>
): CameraState => {
  switch (action.type) {
    case "GET_CAMERAS":
      return {
        ...state,
        cameras: action.payload,
        empty: false,
      };
    case "CAMERA_SELECT":
      return {
        ...state,
        deviceId: action.payload.deviceId,
        kind: action.payload.kind,
        label: action.payload.label,
        empty: false,
      };
    case "CAMERA_CHANGE":
      return {
        ...state,
        [action.payload.field]: action.payload.newCamera,
      };
    case "CAMERA_ERROR":
      return {
        ...state,
        error: action.payload,
      };
    case "CAMERA_EMPTY":
      return {
        ...state,
        empty: true,
      };
    case "CAMERA_RESET":
      return initialState;
    default:
      return state;
  }
};

export default cameraReducer;
